import { memo, useCallback } from 'react';
import ClientTypeahead from './ClientTypeahead';

export const GuestFirstnameField = memo(function GuestFirstnameField({
    fieldName,
    roomIndex,
    guestIndex,
    guestFirstname,
    firstnameRelatedField,
    firstnameSuggestionsMenuOptions,
    onSelectClient,
    onGuestUpdate,
}) {
    const handleChange = useCallback((event) => {
        onGuestUpdate(roomIndex, guestIndex, 'firstname', event.target.value);
    }, [onGuestUpdate, roomIndex, guestIndex]);

    return (
        <ClientTypeahead
            value={guestFirstname}
            name={fieldName}
            onChange={handleChange}
            displayKey="client_firstname"
            searchParamName="first-name"
            relatedField={firstnameRelatedField}
            onSelectClient={onSelectClient}
            suggestionsMenuOptions={firstnameSuggestionsMenuOptions} />
    );
});
